/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

import './types';
const baseUrl = 'navconfig';
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * delete-/navconfig/v5/navconfig/cache
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+invalidateCache&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-delete-%2Fnavconfig%2Fv5%2Fnavconfig%2Fcache'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/delete/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig%2Fcache?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const invalidateCacheRpc = freeze({
  baseUrl,
  method: 'delete',
  pathSegments: freeze(['v5/navconfig/cache'])
});